module.exports = __webpack_public_path__ + "media/press/aol_quote_620x110-5c8441ec.png";